import React from 'react';
import { Card, CardContent } from './ui/card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';
import { testimonials } from '../data/mockData';
import { Quote } from 'lucide-react';
import Autoplay from 'embla-carousel-autoplay';

const Testimonials = () => {
  const plugin = React.useRef(
    Autoplay({ delay: 5000, stopOnInteraction: false })
  );

  return (
    <section className="py-24 bg-[#37464F] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(0,150,136,0.05),transparent_50%)]"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Word On The Wrist
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Don't take it from us. Take it from the people clipping wristbands on guests every day
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="max-w-5xl mx-auto">
          <Carousel
            plugins={[plugin.current]}
            className="w-full"
            onMouseEnter={plugin.current.stop}
            onMouseLeave={plugin.current.reset}
          >
            <CarouselContent>
              {testimonials.map((testimonial, index) => (
                <CarouselItem key={index} className="md:basis-1/1 lg:basis-1/1">
                  <div className="p-4">
                    <Card className="bg-[#101F27]/80 border-gray-700 hover:border-[#009688]/50 transition-all duration-300 hover:shadow-xl hover:shadow-[#009688]/10">
                      <CardContent className="p-8 md:p-12">
                        {/* Quote Icon */}
                        <div className="mb-6">
                          <div className="inline-flex p-3 bg-gradient-to-br from-[#009688]/20 to-[#005B4F]/20 rounded-lg">
                            <Quote className="w-8 h-8 text-[#009688]" />
                          </div>
                        </div>

                        {/* Testimonial Text */}
                        <p className="text-gray-200 leading-relaxed mb-8 text-xl md:text-2xl font-light">
                          "{testimonial.quote}"
                        </p>

                        {/* Author Info */}
                        <div className="flex items-center space-x-4 pt-6 border-t border-gray-700">
                          <img
                            src={testimonial.image}
                            alt={testimonial.author}
                            className="w-16 h-16 rounded-full object-cover border-2 border-[#009688]/30"
                          />
                          <div>
                            <div className="font-semibold text-white text-lg">{testimonial.author}</div>
                            <div className="text-sm text-gray-400">
                              {testimonial.role}, {testimonial.company}
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="hidden md:flex -left-12 bg-[#009688] hover:bg-[#005B4F] text-white border-none" />
            <CarouselNext className="hidden md:flex -right-12 bg-[#009688] hover:bg-[#005B4F] text-white border-none" />
          </Carousel>
        </div>

        {/* Carousel Indicators */}
        <div className="flex justify-center mt-8 space-x-2">
          {testimonials.map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-gray-600 opacity-50"
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
